// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--growth-starburst/wac-product-activation-checklist';

import { MessageFrontend as createMessageFrontendProductActivationChecklist } from '@post-office/browser--growth-starburst/product-activation-checklist/placements/in-app-v2/wac-product-activation-checklist';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type WacProductActivationChecklistPlacementProps } from '@post-office/browser--growth-starburst/wac-product-activation-checklist/registry-props';
import { type ComponentType } from 'react';

export type { WacProductActivationChecklistPlacementProps } from '@post-office/browser--growth-starburst/wac-product-activation-checklist/registry-props';

const messageFrontends = [
	createMessageFrontendProductActivationChecklist({
		messageTemplateId: 'product-activation-checklist',
	}),
];

export const RawPlacement: PlacementRendererStage<WacProductActivationChecklistPlacementProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<WacProductActivationChecklistPlacementProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<WacProductActivationChecklistPlacementProps> =
	RawPlacement;
